import { Megaphone, MapPin, Tag, Gift } from "lucide-react";
import { GlassCard, SectionHeading } from "./GlassCard";

const modules = [
  {
    icon: Megaphone,
    title: "National campaigns",
    desc: "Your shop featured in Gromza's country-wide marketing pushes — offers, promotions and festival sales that put your brand on the national map.",
    tag: "B2B Reach",
  },
  {
    icon: MapPin,
    title: "Hyper-local pins",
    desc: "Drop a golden pin on your exact lane. Customers within 3-5 km see your shop first — distance-sorted, map-visible, walk-in ready.",
    tag: "3-5 KM Radius",
  },
  {
    icon: Tag,
    title: "Best Offers Yaha!",
    desc: "Daily deals, exclusive discounts and dhamakedaar offers pushed straight to the B2C offers feed — shoppers save more, you sell more.",
    tag: "B2C Offers",
  },
];

export const GrowthEngine = () => (
  <section id="growth" data-testid="growth-section" className="relative py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <SectionHeading
        testId="growth-heading"
        eyebrow="Growth Engine & Ads"
        title="Market once."
        highlight="Sell everywhere."
        description="Floating growth modules that work while you sleep — national visibility, neighbourhood precision, and offers that convert browsers into buyers."
        align="center"
      />

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {modules.map((m, i) => (
          <GlassCard key={m.title} testId={`growth-module-${i}`} delay={i} className="p-9 group relative overflow-hidden">
            <div className="absolute -top-12 -right-12 w-40 h-40 rounded-full bg-amber-400/10 blur-3xl group-hover:bg-amber-400/25 transition-colors duration-700" />
            <div className="relative">
              <span className="inline-block rounded-full bg-amber-400/15 border border-amber-400/30 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-amber-300 mb-6">
                {m.tag}
              </span>
              <div className="w-12 h-12 rounded-xl bg-amber-400/10 border border-amber-400/25 flex items-center justify-center mb-5 group-hover:bg-amber-400/20 transition-colors duration-400">
                <m.icon size={22} className="text-amber-400" />
              </div>
              <h3 className="font-display text-2xl font-semibold mb-3">{m.title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{m.desc}</p>
            </div>
          </GlassCard>
        ))}
      </div>

      <GlassCard testId="growth-referral-card" delay={1} className="mt-6 p-10 relative overflow-hidden group">
        <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-amber-400/10 blur-3xl group-hover:bg-amber-400/20 transition-colors duration-700" />
        <div className="relative flex flex-col lg:flex-row lg:items-center gap-10">
          <div className="flex-1">
            <div className="w-14 h-14 rounded-2xl bg-amber-400/10 border border-amber-400/25 flex items-center justify-center mb-6">
              <Gift size={26} className="text-amber-400" />
            </div>
            <h3 className="font-display text-2xl sm:text-3xl font-semibold mb-4">
              Refer &amp; Earn <span className="gold-text">+30 Days Free</span>
            </h3>
            <p className="text-base text-slate-400 leading-relaxed max-w-lg">
              Invite a fellow shopkeeper and both of you get 30 extra days added to your subscription.
              Growth that pays for itself — jitna refer, utna free.
            </p>
          </div>
          <div className="flex gap-4">
            <div className="rounded-2xl bg-white/[0.04] border border-white/10 px-6 py-5 text-center">
              <p className="font-display text-3xl font-semibold text-amber-400">+30</p>
              <p className="text-xs text-slate-500 mt-1">days for you</p>
            </div>
            <div className="rounded-2xl bg-white/[0.04] border border-white/10 px-6 py-5 text-center">
              <p className="font-display text-3xl font-semibold text-amber-400">+30</p>
              <p className="text-xs text-slate-500 mt-1">days for them</p>
            </div>
            <div className="rounded-2xl bg-white/[0.04] border border-white/10 px-6 py-5 text-center">
              <p className="font-display text-3xl font-semibold text-amber-400">∞</p>
              <p className="text-xs text-slate-500 mt-1">referrals</p>
            </div>
          </div>
        </div>
      </GlassCard>
    </div>
  </section>
);
